import { defineComponent, computed } from 'vue'
import { useMainStore } from '@/store/main/main'
import { useAuthStore } from '@/store/auth/auth'
import { useLogout } from '@/composables/useLogout'
import { useUIStore } from '@/store/ui/ui'
import type { MenuItem } from '@/types/lists'

export default defineComponent({
  name: 'ApiDocsHeader',
  props: {},
  emits: ['toggleMenu'],
  setup() {
    const mainStore = useMainStore()
    const authStore = useAuthStore()
    const uiStore = useUIStore()
    const { logout } = useLogout()

    const isMobile = computed(() => mainStore.isMobile)
    const isMenuOpen = computed(() => uiStore.getIsApiDocsMenuOpen)

    const userMenuItems: MenuItem[] = [
      {
        title: 'Личный кабинет',
        route: '/profile',
      },
      {
        title: 'Выйти',
        color: 'red',
        callback: 'logout',
      },
    ]

    return { isMobile, authStore, isMenuOpen, userMenuItems, logout }
  },
})
